// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__148AA","productName":"Table_productName__CUsMk"};